import React from 'react';
import {Box} from '@mui/material';
import {ACTE_COULEURS} from '../tokens.js';

/** Pilule de nature d'acte : `type` ∈ lavage | maint | graffiti | probleme, `libelle` ex. « Lavage 2/2 ». */
export default function PiluleActe({type, libelle}) {
    const c = ACTE_COULEURS[type] || ACTE_COULEURS.lavage;
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex', alignItems: 'center', height: 24, px: '10px', borderRadius: '999px',
                backgroundColor: c.fond, color: c.encre, border: c.bordure ? `1px solid ${c.bordure}` : 'none',
                fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap',
            }}
        >
            {libelle}
        </Box>
    );
}
